import { useSelector } from 'react-redux';
import { getBaccaratTotalAmounts } from '../selectors';

export const useGameTotalsAmount = () => useSelector(getBaccaratTotalAmounts);
